
import * as echarts from 'echarts';
import Subtitle from "../components/subtitle.vue"
import moment from 'moment';

import { getProNameList, getWeather } from "@/api/project";
import { getAllProject, getDeviceInfo, getWaterInfo, getElectricInfo, getGasInfo, getTotleCost, getWaterTrendByCode, getElectricTrendByCode, getGasTrendByCode, getProjectBoilerGas } from "@/api/energy";
import { init } from 'echarts';

let optionLine = {
	color: ['#1FBDFF', '#FFC300', '#F7725B', '#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de', '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc'],
	grid: {
		top: '13%',
		left: '4%',
		right: '6%',
		bottom: '10%',
		containLabel: true
	},
	tooltip: {
		trigger: 'axis'
	},
	xAxis: {
		type: 'category',
		boundaryGap: false,
		data: []
	},
	yAxis: {
		type: 'value'
	},
	series: [
		{
			name: 'gas',
			data: [],
			type: 'line',
			symbol: "emptyCircle",
			symbolSize: 8,
			areaStyle: {
				color: {
					x: 0, y: 0, x2: 0, y2: 1,
					colorStops: [{
						offset: 0, color: 'rgba(31, 189, 255, 1)' // 0% 处的颜色
					}, {
						offset: 1, color: 'rgba(31, 189, 255, 0)' // 100% 处的颜色
					}],
				}
			}
		}
	]
};

let optionBar = {
	color: ['#22BEFF'],
	tooltip: {
		trigger: 'axis',
		axisPointer: {
			type: 'shadow'
		}
	},
	grid: {
		top: '13%',
		left: '4%',
		right: '6%',
		bottom: '10%',
		containLabel: true
	},
	xAxis: [
		{
			type: 'category',
			data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
			axisTick: {
				alignWithLabel: true
			}
		}
	],
	yAxis: [
		{
			type: 'value'
		}
	],
	series: [
		{
			name: 'gas',
			type: 'bar',
			barWidth: '40%',
			data: [0, 0, 0, 0, 0, 0, 0]
		}
	]
};

export default {
	name: 'projectEnergy',
	components: {
		Subtitle,
	},
	data() {
		return {
			proCode: '',
			proName: '',
			adCode: '',
			projectId: '',
			proNameList: [],
			newDate: moment().format('YYYY/MM/DD HH:mm:ss'),
			timer: null,
			weather: {},

			energyArr: [
				{
					id: 'water',
					titleName: '水',
					icon: require('../../../assets/images/energy/small-water.png'),
					tableData: [
						{
							time: "时间",
							num: '用水量',
							perCent: null,
							cost: '用水费用（元）'
						}, {
							time: "昨日",
							num: 0,
							perCent: 0,
							cost: 0,
						}, {
							time: "本月",
							num: 0,
							perCent: 0,
							cost: 0
						}, {
							time: "本季度",
							num: 0,
							perCent: 0,
							cost: 0
						}, {
							time: "本年",
							num: 0,
							perCent: 0,
							cost: 0
						},
					],
				}, {
					id: 'electricity',
					titleName: '电',
					icon: require('../../../assets/images/energy/small-electricity.png'),
					tableData: [
						{
							time: "时间",
							num: '用电量',
							perCent: null,
							cost: '用电费用（元）'
						}, {
							time: "昨日",
							num: 0,
							perCent: 0,
							cost: 0,
						}, {
							time: "本月",
							num: 0,
							perCent: 0,
							cost: 0
						}, {
							time: "本季度",
							num: 0,
							perCent: 0,
							cost: 0
						}, {
							time: "本年",
							num: 0,
							perCent: 0,
							cost: 0
						},
					],
				}, {
					id: 'gas',
					titleName: '燃气',
					icon: require('../../../assets/images/energy/small-gas.png'),
					tableData: [
						{
							time: "时间",
							num: '用燃气量',
							perCent: null,
							cost: '用燃气费用（元）'
						}, {
							time: "昨日",
							num: 0,
							perCent: 0,
							cost: 0,
						}, {
							time: "本月",
							num: 0,
							perCent: 0,
							cost: 0
						}, {
							time: "本季度",
							num: 0,
							perCent: 0,
							cost: 0
						}, {
							time: "本年",
							num: 0,
							perCent: 0,
							cost: 0
						},
					],
				},
			],

			timing: 'month',//总费用占比选择时间
			costPercentData: [
				{ value: 0, name: '水费用' },
				{ value: 0, name: '电费用' },
				{ value: 0, name: '燃气费用' },
			],

			deviceNum: [
				{
					imgUrl: require('../../../assets/images/energy/all-dev.png'),
					text: '总设备数量：',
					num: 0,
				}, {
					imgUrl: require('../../../assets/images/energy/boiler.png'),
					text: '锅炉设备：',
					num: 0,
				}, {
					imgUrl: require('../../../assets/images/energy/water-pump .png'),
					text: '水泵设备：',
					num: 0,
				}, {
					imgUrl: require('../../../assets/images/energy/else.png'),
					text: '其它设备：',
					num: 0,
				},
			],

			tabPosition: 'month',
			pickerOptions: {//日期选择，快捷选项
				disabledDate(time) {
					return time.getTime() > Date.now() - 8.64e6
				},
				shortcuts: [{
					text: '最近一周',
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
						picker.$emit('pick', [start, end]);
					}
				}, {
					text: '最近一个月',
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
						picker.$emit('pick', [start, end]);
					}
				}, {
					text: '最近三个月',
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
						picker.$emit('pick', [start, end]);
					}
				}]
			},
			dateValue: [moment().startOf('months').format("YYYY-MM-DD HH:mm:ss"), moment().format("YYYY-MM-DD HH:mm:ss")],

			echartArr: [
				{
					name: '水（t）',
					type: 'line',
					titleName: '用水趋势图',
					className: 'waterEchart',
					option: optionLine,
					xAxisData: [],
					seriesData: [],
					color: ['#1FBDFF'],
					colorStops: [{ offset: 0, color: 'rgba(31, 189, 255, 1)' }, { offset: 1, color: 'rgba(31, 189, 255, 0)' }]
				}, {
					name: '电（kw·h）',
					type: 'line',
					titleName: '用电趋势图',
					className: 'electricityEchart',
					option: optionLine,
					xAxisData: [],
					seriesData: [],
					color: ['#FFC300'],
					colorStops: [{ offset: 0, color: 'rgba(255, 195, 0, 1)' }, { offset: 1, color: 'rgba(255, 195, 0, 0)' }]
				}, {
					name: '燃气（m³）',
					type: 'line',
					titleName: '燃气用量趋势图',
					className: 'gasEchart',
					option: optionLine,
					xAxisData: [],
					seriesData: [],
					color: ['#F7725B'],
					colorStops: [{ offset: 0, color: 'rgba(247, 114, 91, 1)' }, { offset: 1, color: 'rgba(247, 114, 91, 0)' }]
				}, {
					name: '燃气用量（m³）',
					type: 'bar',
					titleName: '锅炉燃气用量',
					className: 'boilerGasEchart',
					option: optionBar,
					xAxisData: [],
					seriesData: [0],
					color: ['#1FBDFF'],
					colorStops: [{ offset: 0, color: 'rgba(31, 189, 255, 1)' }, { offset: 1, color: 'rgba(31, 189, 255, 0)' }]
				},
			],

		}
	},

	computed: {

	},
	watch: {
		adCode() {
			this.getWeather()//获取天气
		},
		proCode() {
			this.getWaterInfo()//水
			this.getElectricInfo()//电
			this.getGasInfo()//气

			this.getTotleCost()//费用占比

			this.getWaterTrendByCode()//水电气趋势图
			// this.getElectricTrendByCode()//水电气趋势图
			// this.getGasTrendByCode()//水电气趋势图
		},
		timing() {
			this.getTotleCost()//费用占比
		},
		projectId() {
			this.getDeviceInfo()//设备数量
			this.getProjectBoilerGas()//锅炉燃气用量
		},
		tabPosition(val) {
			switch (val) {
				case 'day'://当天
					this.dateValue = [moment().subtract(1, 'days').format("YYYY-MM-DD 00:00:00"), moment().subtract(1, 'days').format("YYYY-MM-DD 23:59:59")]
					break;
				case 'month'://本月
					this.dateValue = [moment().startOf('months').format("YYYY-MM-DD HH:mm:ss"), moment().format("YYYY-MM-DD HH:mm:ss")]
					break;
				case 'quarter'://本季度
					this.dateValue = [moment().startOf('quarters').format("YYYY-MM-DD HH:mm:ss"), moment().format("YYYY-MM-DD HH:mm:ss")]
					break;
				case 'year'://本年
					this.dateValue = [moment().startOf('year').format("YYYY-MM-DD HH:mm:ss"), moment().format("YYYY-MM-DD HH:mm:ss")]
					break;
			}
			this.getWaterTrendByCode()//水电气趋势图
			// this.getElectricTrendByCode()//水电气趋势图
			// this.getGasTrendByCode()//水电气趋势图
		},
	},

	created() {
		this.init()

	},
	mounted() {

	},

	beforeDestroy() {
		clearInterval(this.timer)
	},

	methods: {
		init() {
			this.getProNameList()
			this.timer = setInterval(() => {
				this.newDate = moment().format('YYYY/MM/DD HH:mm:ss')
			}, 1000)
		},

		//选择了时间通过时间请求接口
		handleOnChange() {
			this.tabPosition = moment(this.dateValue[0]).format("YYYY-MM-DD") + ',' + moment(this.dateValue[1]).format("YYYY-MM-DD")
			this.getWaterTrendByCode()//水电气趋势图
		},

		//请求项目列表
		async getProNameList() {
			const res = await getProNameList()
			if (res.code == 200) {
				this.proNameList = res.data
				res.data.forEach(el => {
					if (el.pro_code === "PRO00020340") {//设定为 良乡社科院项目
						this.proCode = el.pro_code
						this.proName = el.pro_name
						this.adCode = el.adCode
						this.projectId = el.id
					}
				})
				// this.proCode = res.data[0].pro_code
				// this.proName = res.data[0].pro_name
				// this.adCode = res.data[0].adCode
				// this.projectId = res.data[0].id
			}
			// const res1 = await getAllProject()
		},

		//选择项目
		handleChangeProjectId(val) {
			this.proCode = val
			this.proName = this.proNameList.filter(el => el.pro_code === val)[0].pro_name
			this.adCode = this.proNameList.filter(el => el.pro_code === val)[0].adCode
			this.projectId = this.proNameList.filter(el => el.pro_code === val)[0].id
		},

		//设备数量
		async getDeviceInfo() {
			const res = await getDeviceInfo(this.projectId)
			if (res.code) {
				this.deviceNum[0].num = res.data.totleNum
				this.deviceNum[1].num = res.data.boilerNum
				this.deviceNum[2].num = res.data.waterNum
				this.deviceNum[3].num = res.data.otherNum
				// this.createEchart()
			}
		},

		//项目下水能耗信息
		async getWaterInfo() {
			const res = await getWaterInfo(this.proCode)
			if (res.code == 200) {
				this.energyArr[0].tableData[1].cost = res.data.dayCost
				this.energyArr[0].tableData[1].num = res.data.dayNum
				this.energyArr[0].tableData[1].perCent = res.data.dayRatio

				this.energyArr[0].tableData[2].cost = res.data.monthCost
				this.energyArr[0].tableData[2].num = res.data.monthNum
				this.energyArr[0].tableData[2].perCent = res.data.monthRatio

				this.energyArr[0].tableData[3].cost = res.data.quarterCost
				this.energyArr[0].tableData[3].num = res.data.quarterNum
				this.energyArr[0].tableData[3].perCent = res.data.quarterRatio

				this.energyArr[0].tableData[4].cost = res.data.yearCost
				this.energyArr[0].tableData[4].num = res.data.yearNum
				this.energyArr[0].tableData[4].perCent = res.data.yearRatio
			}
		},

		//项目下电能耗信息
		async getElectricInfo() {
			const res = await getElectricInfo(this.proCode)
			if (res.code == 200) {
				this.energyArr[1].tableData[1].cost = res.data.dayCost
				this.energyArr[1].tableData[1].num = res.data.dayNum
				this.energyArr[1].tableData[1].perCent = res.data.dayRatio

				this.energyArr[1].tableData[2].cost = res.data.monthCost
				this.energyArr[1].tableData[2].num = res.data.monthNum
				this.energyArr[1].tableData[2].perCent = res.data.monthRatio

				this.energyArr[1].tableData[3].cost = res.data.quarterCost
				this.energyArr[1].tableData[3].num = res.data.quarterNum
				this.energyArr[1].tableData[3].perCent = res.data.quarterRatio

				this.energyArr[1].tableData[4].cost = res.data.yearCost
				this.energyArr[1].tableData[4].num = res.data.yearNum
				this.energyArr[1].tableData[4].perCent = res.data.yearRatio
			}
		},

		//项目下燃气能耗信息
		async getGasInfo() {
			const res = await getGasInfo(this.proCode)
			if (res.code == 200) {
				this.energyArr[2].tableData[1].cost = res.data.dayCost
				this.energyArr[2].tableData[1].num = res.data.dayNum
				this.energyArr[2].tableData[1].perCent = res.data.dayRatio

				this.energyArr[2].tableData[2].cost = res.data.monthCost
				this.energyArr[2].tableData[2].num = res.data.monthNum
				this.energyArr[2].tableData[2].perCent = res.data.monthRatio

				this.energyArr[2].tableData[3].cost = res.data.quarterCost
				this.energyArr[2].tableData[3].num = res.data.quarterNum
				this.energyArr[2].tableData[3].perCent = res.data.quarterRatio

				this.energyArr[2].tableData[4].cost = res.data.yearCost
				this.energyArr[2].tableData[4].num = res.data.yearNum
				this.energyArr[2].tableData[4].perCent = res.data.yearRatio
			}
		},

		//费用占比
		async getTotleCost() {
			const res = await getTotleCost(this.proCode, this.timing)
			if (res.code) {
				this.costPercentData[0].value = res.data.waterPercent
				this.costPercentData[1].value = res.data.electricPercent
				this.costPercentData[2].value = res.data.gasPercent
				this.costOfEchart()
			}
		},

		//费用占比
		costOfEchart() {
			let option = {
				color: ['#00B4FF', '#FFC300', '#F7725B'],
				tooltip: {
					trigger: 'item',
					formatter: '{b}：{d}%',
				},
				legend: {
					orient: 'horizontal',
					bottom: '3%',
					data: [
						{
							name: '水费用',
							icon: 'circle',
						}, {
							name: '电费用',
							icon: 'circle',
						}, {
							name: '燃气费用',
							icon: 'circle',
						},
					]
				},
				series: [
					{
						name: '费用占比',
						type: 'pie',
						radius: '50%',
						center: ['50%', '45%'],
						data: this.costPercentData,
						emphasis: {
							itemStyle: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: 'rgba(0, 0, 0, 0.5)'
							}
						},
						label: {
							show: true,
							formatter: '{b}：{d}%',
							fontSize: 12,
							color: '#999',
							// rotate:90,
							// offset:[0, -10],
							overflow: 'break',//换行

						}
					}
				]
			};
			let myChart = echarts.init(document.getElementById('costofEchart'));
			myChart.setOption(option);
		},

		//水趋势图
		async getWaterTrendByCode() {
			// const res = await getWaterTrendByCode(this.proCode, this.tabPosition)
			// const res1 = await getElectricTrendByCode(this.proCode, this.tabPosition)
			// const res2 = await getGasTrendByCode(this.proCode, this.tabPosition)

			getWaterTrendByCode(this.proCode, this.tabPosition).then(res => {
				if (res.code == 200) {
					this.echartArr[0].xAxisData = []
					this.echartArr[0].seriesData = []
					res.data.forEach(el => {
						this.echartArr[0].xAxisData.push(this.tabPosition === 'year' ? Number(el.time) + '月' : el.time)
						this.echartArr[0].seriesData.push(el.value)
					})

					this.echartArr[0].option.color = this.echartArr[0].color
					this.echartArr[0].option.series[0].areaStyle.color.colorStops = this.echartArr[0].colorStops
					this.echartArr[0].option.xAxis.data = this.echartArr[0].xAxisData
					this.echartArr[0].option.series[0].data = this.echartArr[0].seriesData
					this.echartArr[0].option.series[0].name = this.echartArr[0].name
					let myChart = echarts.init(document.getElementById(this.echartArr[0].className));
					myChart.clear()
					myChart.setOption(this.echartArr[0].option);
				}
			})
			getElectricTrendByCode(this.proCode, this.tabPosition).then(res => {
				if (res.code == 200) {
					this.echartArr[1].xAxisData = []
					this.echartArr[1].seriesData = []
					res.data.forEach(el => {
						this.echartArr[1].xAxisData.push(this.tabPosition === 'year' ? Number(el.time) + '月' : el.time)
						this.echartArr[1].seriesData.push(el.value)
					})

					this.echartArr[1].option.color = this.echartArr[1].color
					this.echartArr[1].option.series[0].areaStyle.color.colorStops = this.echartArr[1].colorStops
					this.echartArr[1].option.xAxis.data = this.echartArr[1].xAxisData
					this.echartArr[1].option.series[0].data = this.echartArr[1].seriesData
					this.echartArr[1].option.series[0].name = this.echartArr[1].name
					let myChart = echarts.init(document.getElementById(this.echartArr[1].className));
					myChart.clear()
					myChart.setOption(this.echartArr[1].option);
				}
			})
			getGasTrendByCode(this.proCode, this.tabPosition).then(res => {
				if (res.code == 200) {
					this.echartArr[2].xAxisData = []
					this.echartArr[2].seriesData = []
					res.data.forEach(el => {
						this.echartArr[2].xAxisData.push(this.tabPosition === 'year' ? Number(el.time) + '月' : el.time)
						this.echartArr[2].seriesData.push(el.value)
					})

					this.echartArr[2].option.color = this.echartArr[2].color
					this.echartArr[2].option.series[0].areaStyle.color.colorStops = this.echartArr[2].colorStops
					this.echartArr[2].option.xAxis.data = this.echartArr[2].xAxisData
					this.echartArr[2].option.series[0].data = this.echartArr[2].seriesData
					this.echartArr[2].option.series[0].name = this.echartArr[2].name
					let myChart = echarts.init(document.getElementById(this.echartArr[2].className));
					myChart.clear()
					myChart.setOption(this.echartArr[2].option);
				}
			})

			// if (res1.code == 200) {
			// 	this.echartArr[1].xAxisData = []
			// 	this.echartArr[1].seriesData = []
			// 	res1.data.forEach(el=>{
			// 		this.echartArr[1].xAxisData.push(el.time)
			// 		this.echartArr[1].seriesData.push(el.value)
			// 	})
			// }
			// if (res2.code == 200) {
			// 	this.echartArr[2].xAxisData = []
			// 	this.echartArr[2].seriesData = []
			// 	res2.data.forEach(el=>{
			// 		this.echartArr[2].xAxisData.push(el.time)
			// 		this.echartArr[2].seriesData.push(el.value)
			// 	})
			// }
			// this.createEchart()
		},
		// //电趋势图
		// async getElectricTrendByCode() {
		// 	const res = await getElectricTrendByCode(this.proCode, this.tabPosition)
		// 	console.log(res, 444)
		// 	if (res.code == 200) {
		// 		this.echartArr[1].xAxisData = []
		// 		this.echartArr[1].seriesData = []
		// 		res.data.forEach(el=>{
		// 			this.echartArr[1].xAxisData.push(el.time)
		// 			this.echartArr[1].seriesData.push(el.value)
		// 		})
		// 		this.createEchart()
		// 	}
		// },
		// //燃气趋势图
		// async getGasTrendByCode() {
		// 	const res = await getGasTrendByCode(this.proCode, this.tabPosition)
		// 	console.log(res, 555)
		// 	if (res.code == 200) {
		// 		this.echartArr[2].xAxisData = []
		// 		this.echartArr[2].seriesData = []
		// 		res.data.forEach(el=>{
		// 			this.echartArr[2].xAxisData.push(el.time)
		// 			this.echartArr[2].seriesData.push(el.value)
		// 		})
		// 		this.createEchart()
		// 	}
		// },


		//锅炉燃气用量
		async getProjectBoilerGas() {
			const res = await getProjectBoilerGas(this.projectId)
			if (res.code == 200) {
				this.echartArr[3].xAxisData = []
				this.echartArr[3].seriesData = []
				res.data.forEach(el => {
					this.echartArr[3].xAxisData.push(el.boilerName)
					this.echartArr[3].seriesData.push(el.gasNum ? el.gasNum : 0)
				})
				this.echartArr[3].option.xAxis[0].data = this.echartArr[3].xAxisData
				this.echartArr[3].option.series[0].data = this.echartArr[3].seriesData
				this.echartArr[3].option.series[0].name = this.echartArr[3].name
				let myChart = echarts.init(document.getElementById(this.echartArr[3].className));
				myChart.clear()
				myChart.setOption(this.echartArr[3].option);
			}
		},

		createEchart() {
			// let xAxisData = ['12-01', '12-02', '12-03', '12-04', '12-05', '12-06', '12-07', '12-08', '12-09', '12-10']
			// let seriesData = [3, 4, 5, 8, 12, 15, 19, 22, 28, 35]
			let xAxisDataBar = []
			let seriesDataBar = [0]
			for (let i = 0; i < this.deviceNum[1].num; i++) {
				xAxisDataBar.push('锅炉' + (i + 1))
				seriesDataBar.push(0)
			}

			this.echartArr.forEach(el => {
				// if (el.type === 'line') {
				// 	// el.xAxisData = xAxisData
				// 	// el.seriesData = seriesData
				// 	el.option = option
				// 	el.option.color = el.color
				// 	el.option.series[0].areaStyle.color.colorStops = el.colorStops
				// }
				if (el.type === 'bar') {
					el.xAxisData = xAxisDataBar
					el.seriesData = seriesDataBar

					el.option.xAxis[0].data = el.xAxisData
					el.option.series[0].data = el.seriesData
					el.option.series[0].name = el.name
					let myChart = echarts.init(document.getElementById(el.className));
					myChart.clear()
					myChart.setOption(el.option);
				}
			});
		},








		//点击跳转更多
		handleClickMore() {
			this.$router.push({
				name: 'energyHistory',
				query: { proCode: this.proCode }
			})
		},





		//获取天气
		async getWeather() {
			const res = await getWeather([this.adCode])
			if (res.code == 200) {
				this.weather = res.data[0]
				if (this.weather.now.text.indexOf('雨') != -1) {
					this.$set(this.weather, 'url', require('../../../assets/images/weather-icon/rain.png'))
				} else if (this.weather.now.text.indexOf('雪') != -1) {
					this.$set(this.weather, 'url', require('../../../assets/images/weather-icon/snow.png'))
				} else if (this.weather.now.text.indexOf('风') != -1) {
					this.$set(this.weather, 'url', require('../../../assets/images/weather-icon/wind.png'))
				} else if (this.weather.now.text.indexOf('晴') != -1) {
					this.$set(this.weather, 'url', require('../../../assets/images/weather-icon/sun.png'))
				} else if (this.weather.now.text.indexOf('多云') != -1) {
					this.$set(this.weather, 'url', require('../../../assets/images/weather-icon/cloudy.png'))
				} else if (this.weather.now.text.indexOf('阴') != -1) {
					this.$set(this.weather, 'url', require('../../../assets/images/weather-icon/overcast.png'))
				} else if (this.weather.now.text.indexOf('雾') != -1) {
					this.$set(this.weather, 'url', require('../../../assets/images/weather-icon/fog.png'))
				} else if (this.weather.now.text.indexOf('霾') != -1) {
					this.$set(this.weather, 'url', require('../../../assets/images/weather-icon/Haze.png'))
				}
			}
		},


	}
}